<template>
  <div>
    <el-dialog
      title="选择表单"
      :visible.sync="showDialog"
      width="70%"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :before-close="cancelAction"
    >
      <el-main>
        <el-form
          ref="form"
          :model="form"
          label-width="180px"
        >
          <el-form-item>
            <span slot="label">
              <el-tooltip
                class="item"
                effect="dark"
                content="若已存在用户提交数据，则无法修改已选择的表单模板"
                placement="top"
              >
                <i class="el-icon-question" />
              </el-tooltip>
              表单模板
            </span>
            <el-select
              v-model="form.template_id"
              filterable
              remote
              reserve-keyword
              :remote-method="remoteMethod"
              style="width: 400px"
              placeholder="请输入表单名称"
            >
              <el-option
                v-for="item in options"
                :key="item.template_id"
                :label="item.template_name"
                :value="item.template_id"
              />
            </el-select>
            <!-- <el-link type="primary" class="ml10">配置表单</el-link> -->
          </el-form-item>
          <el-form-item>
            <span slot="label">
              <el-tooltip
                class="item"
                effect="dark"
                content="跳转自定义链接或小程序页面，C端将不会显示奖品核销二维码"
                placement="top"
              >
                <i class="el-icon-question" />
              </el-tooltip>
              表单提交后跳转页面
            </span>

            <el-radio-group v-model="form.type">
              <el-radio label="default">
                默认页面
              </el-radio>
              <el-radio label="channelCode">
                渠道活码
              </el-radio>
              <el-radio label="link">
                自定义链接
              </el-radio>
              <!-- <el-radio label="miniapp">小程序链接</el-radio> -->
            </el-radio-group>
            <div v-if="form.type === 'channelCode'">
              <el-select
                v-model="form.dynamic_code_id"
                filterable
                remote
                reserve-keyword
                :remote-method="remoteCodeMethod"
                style="width: 400px"
                placeholder="请输入活码名称"
              >
                <el-option
                  v-for="item in codeOptions"
                  :key="item.dynamic_code_id"
                  :label="item.channel_name"
                  :value="item.dynamic_code_id"
                />
              </el-select>
            </div>
            <div v-if="form.type === 'link'">
              <el-input
                v-model="form.link"
                placeholder="请输入自定义链接，例：https://shopex.cn"
              />
            </div>
            <div v-if="form.type === 'miniapp'">
              <el-input
                v-model="form.appid"
                placeholder="请输入小程序appid"
              />
              <el-input
                v-model="form.path"
                placeholder="请输入跳转小程序页面路径"
              />
            </div>
          </el-form-item>
        </el-form>
      </el-main>
      <el-footer>
        <el-button @click="cancelAction">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="handleConfirm"
        >
          确定
        </el-button>
      </el-footer>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SelectForm',
  props: {
    selectFormVisible: {
      type: Boolean,
      default: false
    },
    selectFormData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data () {
    return {
      list: [],
      codeList: [],
      options: [],
      codeOptions: [],
      form: {
        type: 'default',
        template_id: '',
        dynamic_code_id: '',
        link: '',
        appid: '',
        path: ''
      }
    }
  },
  computed: {
    showDialog () {
      return this.selectFormVisible
    }
  },
  watch: {
    showDialog (newVal, oldVal) {
      if (newVal) {
        console.log(this.selectFormData)
        if (this.selectFormData[1].text !== '') {
          this.form = this.selectFormData[1]
          this.template_id = this.selectFormData[1].template_id
        }
      } else {
        this.template_id = ''
      }
    }
  },
  created () {
    this.options = this.list
    this.codeOptions = this.codeList
    this.fetch()
  },
  methods: {
    // 关闭模态框
    cancelAction () {
      this.$emit('selectFormVisibleChange', [false])
    },
    handleConfirm () {
      let params = { template_id: this.form.template_id }
      let result = this.list.filter((v) => {
        return v.template_id === params.template_id
      })
      if (result.length === 0) {
        return this.$message.error('请选择表单模版')
      }
      params.selectName = result[0].template_name
      params.type = this.form.type
      if (this.form.type === 'default') {
        params.text = '提交后页面：默认页面'
      } else if (this.form.type === 'channelCode') {
        let result2 = this.codeList.filter((v) => {
          return v.dynamic_code_id === this.form.dynamic_code_id
        })
        if (result2.length === 0) {
          return this.$message.error('请选择渠道活码')
        }
        params.selectCodeName = result2[0].channel_name
        params.dynamic_code_id = this.form.dynamic_code_id
        params.text = `提交后页面：渠道活码（ID：${this.form.dynamic_code_id}）`
      } else if (this.form.type === 'link') {
        params.link = this.form.link
        params.text = `提交后页面：自定义链接（${this.form.link}）`
      } else if (this.form.type === 'miniapp') {
        params.appid = this.form.appid
        params.path = this.form.path
        params.text = `提交后页面：小程序页面（${this.form.path}）`
      }
      console.log(params)
      this.$emit('selectFormVisibleChange', [false, params])
    },
    remoteMethod (query) {
      if (query !== '') {
        this.options = this.list.filter((item) => {
          return item.template_name.indexOf(query) > -1
        })
      } else {
        this.options = this.list
      }
    },
    remoteCodeMethod (query) {
      if (query !== '') {
        this.codeOptions = this.codeList.filter((item) => {
          return item.channel_name.indexOf(query) > -1
        })
      } else {
        this.codeOptions = this.codeList
      }
    },
    async fetch () {
      this.loading = true
      const data = await this.$api.formActivity.getFormsTemplateList(this.formInline).catch(() => {
        this.loading = false
      })
      this.loading = false
      this.list = data.list
      this.options = this.list
      const data2 = await this.$api.formActivity.fetchDynamicCode({}).catch(() => {
        this.loading = false
      })
      this.loading = false
      console.log(data2)
      this.codeList = data2.list
      this.codeOptions = this.codeList
    }
  }
}
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10px;
}
</style>
